import React, { FC } from 'react';
import { Modal, MessageModalLayout, Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ReportTemplateModalSuccessMsg: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} dataHook="report-template-success-msg-modal">
      <MessageModalLayout
        title={t(
          'marketplace.template-page.report-template-modal-success-msg-title',
        )}
        primaryButtonText={t(
          'marketplace.template-page.report-template-modal-success-msg-primary-button',
        )}
        onCloseButtonClick={() => onClose()}
        primaryButtonOnClick={() => onClose()}
      >
        <Box
          direction="vertical"
          gap="27px"
          width="512px"
          dataHook="report-template-success-msg-content"
        >
          <Text size="medium" weight="thin">
            {t(
              'marketplace.template-page.report-template-modal-success-msg-description-1',
            )}
          </Text>
          <Text size="medium" weight="thin">
            {t(
              'marketplace.template-page.report-template-modal-success-msg-description-2',
            )}
          </Text>
        </Box>
      </MessageModalLayout>
    </Modal>
  );
};

export default ReportTemplateModalSuccessMsg;
